import ProfilePhotoUploader from "../component/ProfilePhotoUploader";

function ProfilePhotos() {
    return (
        <div className="profile-photos">
         <ProfilePhotoUploader />
        </div>
    );
}

export default ProfilePhotos;